import { Injectable } from '@angular/core';
import { HttpClient,HttpParams } from '@angular/common/http';
import { environment } from "../../../environments/environment";
@Injectable({
  providedIn: 'root'
})
export class UserService {

  user;
  urlBase = environment.urlApi;
  check;
  constructor(private http: HttpClient) { }

  login(credentials)
  {
    return this.http.post<any>(this.urlBase+"/login",credentials);
  }

  logOut()
  {
    return this.http.post(this.urlBase+"/logout?token="+localStorage.getItem('token'),{});
  }

  getCommandes(page:any)
  {
    return this.http.get(this.urlBase+"/orders?startIndex="+page+"&perpage=20&token="+localStorage.getItem('token'));
  }
  getCommande(id:any)
  {
    return this.http.get(this.urlBase+"/orders/"+id+"?token="+localStorage.getItem('token'));
  }

  getFactures()
  {
    return this.http.get(this.urlBase+"/factures?perpage=1000&token="+localStorage.getItem('token'));
  }

  getFacturesDetails(id){
    return this.http.get(this.urlBase+"/factures/"+id+"?token="+localStorage.getItem('token'));
  }

  statistics(type=null){
    return this.http.get(this.urlBase+"/stats?type="+type+"&token="+localStorage.getItem('token'));
  }

  getProfile()
  {
    return this.http.get(this.urlBase+"/profile?token="+localStorage.getItem('token'));
  }

  getProtfeuille()
  {
    return this.http.get(this.urlBase+"/pf?token="+localStorage.getItem('token'));
  }

  private getRequestOptions() {
    const requestOptions = {
      params: new HttpParams()
    };
    requestOptions.params.set("Set-cookie","laravel_session=t0aWyHoq8Hakmmgvam5TW6YngKOpqvRtZUktQ24v;")
    return requestOptions;
  }

  isLoggedIn() {

     if (localStorage.getItem('token') && localStorage.getItem('token')!='null') {
       const token = localStorage.getItem('token'); // get token from local storage
       const payload = atob(token.split('.')[1]); // decode payload of token
       const parsedPayload = JSON.parse(payload); // convert payload into an Object
       this.check =  parsedPayload.exp > Date.now() / 1000; // check if token is expired
       return this.check;
     }else{
       return this.check;
     }


   }

   checkWithType(){
    var typeCompte = localStorage.getItem('typeCompte');
    if(this.check != undefined && !this.check && typeCompte === 'B2B') {
      localStorage.removeItem('user')
      localStorage.removeItem('typeCompte')
      localStorage.removeItem('token')
    }
    if(typeCompte === 'B2B' && typeCompte && this.isLoggedIn()){
      return true;
    }
    else {
      return false;
    }
  }

  orderBetweenDates(startDate,endDate){
    return this.http.get(this.urlBase+"/orderBetweenDates?startDate="+startDate+"&endDate="+endDate+"&token="+localStorage.getItem('token'));
  }
  changePassword(data){
    return this.http.post(this.urlBase+"/changepassword?token="+localStorage.getItem('token'),data);
  }
  resetPassword(data){
    return this.http.post(this.urlBase+"/resetpassword",data);
  }
}
